import IMemberUserRepository from '../../../domain/interfaces/repositories/IMemberUserRepository'

export const ReadMemberUserValidateSubscriptionByEmailQuery = (
	repository: IMemberUserRepository,
	email: string
) => {
	return repository.validateSubscriptionByEmail(email)
}
